import { render, staticRenderFns } from "./DialogIdeaCover.vue?vue&type=template&id=f486f94c&scoped=true"
import script from "./DialogIdeaCover.vue?vue&type=script&lang=js"
export * from "./DialogIdeaCover.vue?vue&type=script&lang=js"
import style0 from "./DialogIdeaCover.vue?vue&type=style&index=0&id=f486f94c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f486f94c",
  null
  
)

export default component.exports